import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../assets/svg/anl-resolvability.svg',
})
export class AnlResolvabilityComponent {}
